var map = {
	"./abort.svg": "ce29",
	"./accounts.svg": "64eb",
	"./addresses.svg": "692d",
	"./arrow-down.svg": "6ddf",
	"./arrow-dropdown.svg": "8a1b",
	"./arrow-left.svg": "16aa",
	"./arrow-right.svg": "131d",
	"./arrow-up.svg": "f658",
	"./box-arrow-down.svg": "37bd",
	"./cart4.svg": "eb72",
	"./check.svg": "47d4",
	"./circle-info.svg": "d977",
	"./circle-on-off.svg": "a889",
	"./close.svg": "3a98",
	"./cloud-download.svg": "3d33",
	"./dashboard.svg": "fbfe",
	"./deliverystate-available.svg": "6ab0",
	"./deliverystate-inweeks.svg": "25d4",
	"./deliverystate-some.svg": "2cbb",
	"./deliverystate-unavailable.svg": "ce59",
	"./detail.svg": "4613",
	"./edit.svg": "6de2",
	"./globe.svg": "2d22",
	"./history.svg": "4d8c",
	"./list-check.svg": "6895",
	"./location-users.svg": "1bfb",
	"./location.svg": "8543",
	"./locations.svg": "562c",
	"./lock-open.svg": "7da7",
	"./lock.svg": "4c0f",
	"./logout.svg": "5043",
	"./minus.svg": "2c60",
	"./notes.svg": "4baa",
	"./orders.svg": "ad94",
	"./plus.svg": "3962",
	"./professions.svg": "b72b",
	"./reset.svg": "bb6d",
	"./save.svg": "f1ef",
	"./search.svg": "b06f",
	"./send.svg": "835e",
	"./services.svg": "9f44",
	"./trash.svg": "a321",
	"./user-locations.svg": "8a59",
	"./user.svg": "63a5",
	"./users.svg": "8939"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "22a8";